import { render, staticRenderFns } from "./IndexNew.vue?vue&type=template&id=7c055469&scoped=true&"
import script from "./IndexNew.vue?vue&type=script&lang=js&"
export * from "./IndexNew.vue?vue&type=script&lang=js&"
import style0 from "./IndexNew.vue?vue&type=style&index=0&id=7c055469&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c055469",
  null
  
)

export default component.exports